import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

const ArrowDownIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M12 4a1 1 0 0 1 1 1v11.585l5.293-5.292a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 0 1.414l-7 7a1.006 1.006 0 0 1-.09.08l.09-.08a1.008 1.008 0 0 1-.674.292L12 20h-.032l-.054-.004L12 20a1.008 1.008 0 0 1-.617-.213 1.016 1.016 0 0 1-.09-.08l-7-7a1 1 0 0 1 1.414-1.414L11 16.585V5a1 1 0 0 1 1-1z"
        fillRule="nonzero"
      />
    </SvgIcon>
  );
};

export default ArrowDownIcon;
